if (!customElements.get('quick-add-button')) {
  class QuickAddButton extends HTMLElement {
    connectedCallback() {
      this.button = this.querySelector('button');
      this.button.addEventListener('click', this.onButtonClick.bind(this));
    }

    onButtonClick(event) {
      event.preventDefault();

      if (this.dataset.hasVariants === 'true') {
        window.location.href = this.dataset.productUrl;
        return;
      }

      const variantId = this.dataset.variantId;
      if (!variantId) {
        window.location.href = this.dataset.productUrl;
        return;
      }

      const productCard = this.closest('.product-index, .js-product-listing, [data-product-id]');
      if (productCard) {
        const hiddenInput = productCard.querySelector('input[name="id"]');
        const submitTrigger = productCard.querySelector('.js-ajax-submit');
        if (hiddenInput && submitTrigger) {
          hiddenInput.value = variantId;
          submitTrigger.click();
          return;
        }
      }

      this.addToCart(variantId);
    }

    async addToCart(variantId) {
      this.button.disabled = true;
      this.button.setAttribute('aria-busy', 'true');

      try {
        const addRes = await fetch('/cart/add.js', {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
            'X-Requested-With': 'XMLHttpRequest'
          },
          body: JSON.stringify({ items: [{ id: parseInt(variantId, 10), quantity: 1 }] })
        });

        if (!addRes.ok) {
          const err = await addRes.json();
          throw new Error(err.description || 'Could not add to cart');
        }

        const cart = await fetch('/cart.js').then((r) => r.json());

        this.updateCartCount(cart.item_count);
        this.openCartDrawer();
      } catch (err) {
        console.error('[QuickAddButton]', err.message);
      } finally {
        this.button.disabled = false;
        this.button.removeAttribute('aria-busy');
      }
    }

    updateCartCount(count) {
      document.querySelectorAll(
        '[data-cart-count], .js-cart-count, .cart-count, .mini-cart__count'
      ).forEach((el) => {
        el.textContent = count;
      });
    }

    openCartDrawer() {
      const drawer = document.getElementById('slideout-ajax-cart');
      if (drawer) {
        if (typeof drawer.showPopover === 'function') drawer.showPopover();
        return;
      }
      const modal = document.getElementById('modal-ajax-cart');
      if (modal && typeof modal.showPopover === 'function') modal.showPopover();
    }
  }

  customElements.define('quick-add-button', QuickAddButton);
}
